import React from "react";
import { ImInfo } from "react-icons/im";
import useTranslation from "../../hooks/use-translation";
function jsxJoin(array, str) {
    return array.length > 0
        ? array.reduce((result, item) => React.createElement(React.Fragment, null,
            result,
            str,
            item))
        : null;
}
const GeneralTips = ({ tips }) => {
    const { translate } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "strike", style: { paddingBottom: "15px" } },
            React.createElement("span", null,
                React.createElement("span", { className: 'text-dark text-center' },
                    React.createElement(ImInfo, null),
                    translate("general-tips")),
                tips.map(tip => {
                    return (React.createElement(React.Fragment, null,
                        React.createElement("br", null),
                        tip));
                }))),
        React.createElement("div", { className: "separator separator-dots asset__separator" })));
};
export default GeneralTips;
/**
 * const GeneralTips = (props: GeneralTipsProps): JSX.Element => {
 *
 *     return (
 *         <>
 *             <div className="strike mt-4" style={{paddingBottom: "20px"}}>
 *                   <span>
 *                     <span className='text-dark '><ImInfo /> General Tips</span>
 *                     <br/>
 *                     Do not share confidential or personal data.
 *                     <br/>
 *                     Be careful and make sure that the employer is reliable.
 *                     <br/>
 *                     Don't pay money to get hired or to be trained.
 *                   </span>
 *             </div>
 *             <div className="strike" style={{paddingBottom: "20px"}}>
 *                   <span>
 *                     <span className='text-dark '><i className="fas fa-info-circle text-danger"></i> General Tips</span>
 *                     <br/>
 *                     Only meet in public places.
 *                     <br/>
 *                     Never pay or transfer money in advance.
 *                     <br/>
 *                     Inspect the product before you buy it.
 *                   </span>
 *             </div>
 *             <div className="strike" style={{paddingBottom: "20px"}}>
 *                   <span>
 *                     <span className='text-dark '><i className="fas fa-bolt text-success"></i> Regular response time</span>
 *                     <br/>
 *                     Typically replies within 9 hours
 *                   </span>
 *             </div>
 *             <div className="strike" style={{paddingBottom: "50px"}}>
 *                   <span>
 *                     <span className='text-dark '><i className="fas fa-bolt"></i> Regular response time</span>
 *                     <br/>
 *                     Typically replies within 1 day
 *                   </span>
 *             </div>
 *             <div className="d-flex flex-column bd-highlight mb-3" style={{paddingBottom: "50px"}}>
 *                 <span className="">
 *                   <i className="fas fa-heart me-3 text-danger"></i>
 *                     I added your Ad to my favorites
 *                   </span>
 *                 <span className="mt-3">
 *                   <i className="fas fa-phone me-3 text-success"></i>
 *                   I clicked to view your phone number
 *                 </span>
 *                 <span className="mt-3">
 *                   <img className='me-1' src={appleJobIcon} />
 *                   I applied to your job opening
 *                 </span>
 *                 <span className="mt-3">
 *                   <img className='me-1' src={PinnedIcon} />
 *                   I want to be notified when images are added to your Ad
 *                 </span>
 *                 <span className="mt-3">
 *                   <img className='me-1' src={PhotoIcon} />
 *                   I want to be notified when images are added to your Ad
 *                 </span>
 *                 <span className="mt-3">
 *                   <img className='me-1' src={PhotoIcon} />
 *                   I want to be notified if the price drops on your Ad
 *                 </span>
 *                 <span className="mt-3">
 *                   <img className='me-1' src={MapIcon} />
 *                   I want to be notified if a location is added to your Ad
 *                 </span>
 *             </div>
 *         </>
 *     )
 * }
 */ 
